/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseService } from '../property-matrix-base-service';
import { PropertyMatrixConfiguration } from '../property-matrix-configuration';
import { PropertyMatrixStrictHttpResponse } from '../property-matrix-strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ShareInOurDatabaseFormVm } from '../models/share-in-our-database-form-vm';

@Injectable({
  providedIn: 'root',
})
export class ShareInOurDatabaseService extends PropertyMatrixBaseService {
  constructor(
    config: PropertyMatrixConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1ShareInOurDatabaseGenerateSiodVmPost
   */
  static readonly ApiV1ShareInOurDatabaseGenerateSiodVmPostPath = '/api/v1/ShareInOurDatabase/GenerateSiodVM';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ShareInOurDatabaseGenerateSiodVmPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1ShareInOurDatabaseGenerateSiodVmPost$Response(params?: {
    context?: HttpContext
    body?: ShareInOurDatabaseFormVm
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ShareInOurDatabaseService.ApiV1ShareInOurDatabaseGenerateSiodVmPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ShareInOurDatabaseGenerateSiodVmPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1ShareInOurDatabaseGenerateSiodVmPost(params?: {
    context?: HttpContext
    body?: ShareInOurDatabaseFormVm
  }
): Observable<void> {

    return this.apiV1ShareInOurDatabaseGenerateSiodVmPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ShareInOurDatabaseGetPropertyTypesGet
   */
  static readonly ApiV1ShareInOurDatabaseGetPropertyTypesGetPath = '/api/v1/ShareInOurDatabase/GetPropertyTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ShareInOurDatabaseGetPropertyTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ShareInOurDatabaseGetPropertyTypesGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ShareInOurDatabaseService.ApiV1ShareInOurDatabaseGetPropertyTypesGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ShareInOurDatabaseGetPropertyTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ShareInOurDatabaseGetPropertyTypesGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ShareInOurDatabaseGetPropertyTypesGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

}
